export default __webpack_public_path__ + "56b3283075cdf6f8b45171710fbf807d.svg";